import { IBlockService } from './ICryptoService';
import { BlockService } from './CryptoService';

export const block: IBlockService = new BlockService();
